import translate from "./translate";
import copyToClipboard from './copy-to-clipboard';
import Files from "./files";

export default {
  ...translate,
  files : new Files(),
  copyToClipboard
}
